import React, { useState } from "react";
import "../../components/formStyleSheet/FormStyling.css";
import Button from "../button/Button";
import { useForm } from "react-hook-form";
import ModalComponent from "../modalSetup/Modal";
import ImageViewer from "../imageViewer/ImageViewer";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useRequestProductMutation, useRequestVendorProductMutation } from "../../services/Api";
import { useSelector } from "react-redux";

const RequestProductModal = (props) => {

  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");
  const [cnic, setCnic] = useState("");
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [buyerName, setBuyerName] = useState("");
  const [error, setError] = useState('');
  const [phone, setPhone] = useState("");
  const auth = useSelector((data) => data.auth);
  // For vendors, use vendor id (from vendor table), for normal users use user_id
  const userID = auth?.role === "vendor" ? auth?.userDetail?.id : (auth?.userDetail?.user_id || auth?.userDetail?.id);

  const {
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  let { image } = watch();

  const uploadImgHandler = (e) => {
    let { name, files } = e.target;
    setValue(name, files[0]);
  };

  const [requestProduct, { isLoading: requestProductLoading }] = useRequestProductMutation();
  const [requestVendorProduct, { isLoading: requestVendorProductLoading }] = useRequestVendorProductMutation();

  const requestProductHandler = () => {

    let formData = new FormData();

    formData.append('description', description);
    formData.append('user_id', userID);
    formData.append('address', address);
    formData.append('request_image', image);
    formData.append('cnic_number', cnic);

    if (!description) {
      toast.error("Please add description");
    } else if (!address) {
      toast.error("Please add address");
    } else {
      requestProduct({ data: formData })
        .unwrap()
        .then((payload) => {
          if (payload.status) {
            toast.success(payload?.message);
            props.handleCloseRequestProductModal();
          }
        })
        .catch((error) => {
        });
    }
  };

  const vendorRequestProductHandler = () => {

    let formData = new FormData();

    formData.append('product_image', image);
    formData.append('vendor_id', userID);
    formData.append('item_name', productName);
    formData.append('description', description);
    formData.append('item_price', price);
    formData.append('buyer_user', buyerName);
    formData.append('buyer_cnic_number', cnic);
    formData.append('buyer_address', address);
    formData.append('phone_number', phone);

    if (!description) {
      toast.error("Please add description");
    } else if (!address) {
      toast.error("Please add address");
    } else {
      requestVendorProduct({ data: formData })
        .unwrap()
        .then((payload) => {
          if (payload.status) {
            toast.success(payload?.message);
            props.handleCloseRequestProductModal();
          }
        })
        .catch((error) => {
        });
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) {
      setError('Please enter only numbers.');
      return;
    }

    setCnic(value);

    if (value.length < 13) {
      setError('Number must be exactly 13 digits.');
    } else if (value.length > 13) {
      setError('Number must be exactly 13 digits.');
    } else {
      setError('');
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;

    if (/^\+?\d*$/.test(value)) {
      setPhone(value);
    }
  };

  return (
    <ModalComponent
      size="md"
      show={true}
      handleClose={props.handleCloseRequestProductModal}
    >
      <Modal.Body className="overflow m-2 lgModals customScroll pt-0 mt-0">

        <h3 className="fs-1 mb-4 text-center">What were you looking for?</h3>
        <p className="subHeading">Please specify the name, brand and size of your desired item, it really helps.</p>

        <div className="row mt-4">
          <div className="col-12">
            <label className="formLabel">Product Description</label>
            <input
              type="text"
              placeholder="Product Description.."
              className="inputField"
              onChange={(e) => setDescription(e.target.value)}
              value={description}
            />
          </div>

          {auth?.role == "vendor" ?
            <>
              <div className="col-12 mt-4">
                <label className="formLabel">Product Name</label>
                <input
                  type="text"
                  placeholder="Product Name.."
                  className="inputField"
                  onChange={(e) => setProductName(e.target.value)}
                  value={productName}
                />
              </div>

              <div className="col-12 mt-4">
                <label className="formLabel">Product Price</label>
                <input
                  type="number"
                  placeholder="Product Price.."
                  className="inputField"
                  onChange={(e) => setPrice(e.target.value)}
                  value={price}
                />
              </div>

              <div className="col-12 mt-4">
                <label className="formLabel">Buyer Name</label>
                <input
                  type="text"
                  placeholder="Buyer Name.."
                  className="inputField"
                  onChange={(e) => setBuyerName(e.target.value)}
                  value={buyerName}
                />
              </div>

              <div className="col-12 mt-4">
                <label className="formLabel">Phone No.</label>
                <input
                  type="text"
                  placeholder="Phone No..."
                  className="inputField"
                  onChange={(e) => handlePhoneChange(e)}
                  value={phone}
                  maxLength={14}
                />
              </div>
            </>
            : null}

          <div className="col-12 mt-4">
            <label className="formLabel">Address</label>
            <input
              type="text"
              placeholder="Address.."
              className="inputField"
              onChange={(e) => setAddress(e.target.value)}
              value={address}
            />
          </div>

          <div className="col-12 mt-4">
            <label className="formLabel">CNIC</label>
            <input
              type="text"
              placeholder="Type.."
              className="inputField"
              value={cnic}
              onChange={handleChange}
              maxLength={13}
            />
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>

          <div className="col-12 mt-4">
            <label className="formLabel">Product Image</label>

            <div style={{ width: "100%", height: "12rem" }}>
              <ImageViewer
                src={image}
                alt=''
                className='border img-fluid h-100'
              />
            </div>

            <div className='position-relative m-4'>
              <input type="file" className="uploadImgBtn" name='image'
                accept="image/jpeg, image/png, image/jpg" onChange={uploadImgHandler} />
              <p className="my-3 fs-3">Upload
                Image</p>
            </div>
          </div>

          <div className="col-12 mt-4">
            <Button
              label="Request a Product"
              className="greenBtn w-100"
              onClick={() => { auth?.role == "vendor" ? vendorRequestProductHandler() : requestProductHandler() }}
              loading={requestProductLoading || requestVendorProductLoading}
            />
          </div>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
};

export default RequestProductModal;